import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { LanguageService } from '../../Shared/services/language.service';

@Injectable()
export class LanguageUrlSerializerService extends DefaultUrlSerializer {
  private langSynced = false;

  constructor(private langService: LanguageService) {
    super();
  }

  override parse(url: string): UrlTree {
    const { path, tail } = splitPath(url);
    const segments = path.split('/').filter(Boolean);
    const first = segments[0]?.toLowerCase();

    if (first && this.langService.supportedLangs.includes(first)) {
      if (!this.langSynced) {
        this.langService.setLang(first);
      }
      this.langSynced = true;
      const stripped = '/' + segments.slice(1).join('/');
      return super.parse((stripped === '/' ? '/' : stripped) + tail);
    }

    this.langSynced = true;
    return super.parse(url);
  }

  override serialize(tree: UrlTree): string {
    const url = super.serialize(tree);
    const { path, tail } = splitPath(url);
    const first = path.split('/').filter(Boolean)[0]?.toLowerCase();

    if (first && this.langService.supportedLangs.includes(first)) {
      return url;
    }

    const lang = this.langService.resolveLang();
    const cleanPath = path === '/' || path === '' ? '' : path;
    return `/${lang}${cleanPath}${tail}`;
  }
}

function splitPath(url: string): { path: string; tail: string } {
  const idx = url.search(/[?#]/);
  return idx >= 0
    ? { path: url.slice(0, idx), tail: url.slice(idx) }
    : { path: url, tail: '' };
}
